import { render, staticRenderFns } from "./FormScheduledBox.vue?vue&type=template&id=b3a82c9c&"
import script from "./FormScheduledBox.vue?vue&type=script&lang=js&"
export * from "./FormScheduledBox.vue?vue&type=script&lang=js&"
import style0 from "./FormScheduledBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports